import React from 'react';

const PictureSchema = {
  title: 'image title',
  alt: 'image alt',
  src: '/assets/img/placeholder.jpg',
  webp: '/assets/img/placeholder.webp',
};

const Picture = ({ title, alt, src, className, style }) => {
  return (
    <picture style={style} className={className}>
      {/*<source srcSet={"https://cdn.deagostini.com" + webp} type="image/webp" />*/}
      <source srcSet={"https://cdn.deagostini.com" + src} type="image/jpeg" />
      <img width="100%" src={"https://cdn.deagostini.com" + src} alt={alt} title={title || alt} />
    </picture>
  );
};

export default Picture;
export { PictureSchema };
